export const SHEET_LIST=[
    {
        "key":"SHEET_DEV",
        "sheetName":"DEV",
        "value":{
            "api":{
                "base_url":"https://htapi.smallzone.work/admin/rpc",
                "timeout": 240
            },
            "upload_url":"https://htapi.smallzone.work/admin/rpc"
        }
    },
    {
        "key":"SHEET_SIT",
        "sheetName":"SIT",
        "value":{
            "api":{
                "base_url":"https://sitapi.htaq.net/admin/rpc",
                "timeout": 240
            },
            "upload_url":"https://sitapi.htaq.net/admin/rpc"
        }
    },
    {
        "key":"SHEET_UAT",
        "sheetName":"UAT",
        "value":{
            "api":{
                "base_url":"https://uatapi.htaq.net/admin/rpc",
                "timeout": 240
            },
            "upload_url":"https://uatapi.htaq.net/admin/rpc"
        }
    },
]